import { useCallback, useState } from "react"
import { GetApp } from "../../App"
import { UnitSelect } from "../../Components/UnitSelect"
import { BlockField, BlockFieldInputs } from "../../Components/Block"
import { PredefinedSelect } from "../../Components/PredefinedSelect"
import { ShipSingleRowDataItem } from "../../Components/ShipSingleRowDataItem"
import { IShipDataRigElement } from "../../Types"

interface ShipDataRigElementViewProps {
  data: IShipDataRigElement;
  editable: boolean;
  index: number;
  onEdited?: () => void;
  removeRig: () => void;
}

export function ShipDataRigElementView({ data, editable, index, onEdited, removeRig }: ShipDataRigElementViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const namePrefix = `rigElements[${index}].`;

  { /* List for rig elements */ }
  const [rigElement, setRig] = useState<string | undefined>(data.rigElement);
  const predefinedRigs = ["mast", "main_mast", "mizzen_mast", "forestay", "stay", "jib_stay", "backstay", "runner", "baby_stay", "kicker", "vang", "winch"];
  const selectRig = useCallback((value?: string) => {
    setRig(value);
    if (onEdited) {
      onEdited();
    }
  }, []);

  return (
    <ShipSingleRowDataItem namePrefix={namePrefix} id={data.id} rowClassName="block-row-last rig-element-fields-row" onRemove={removeRig}>
      <BlockField label={t("rig_element")}>
        <PredefinedSelect value={rigElement} predefined={predefinedRigs} label={(v) => t(`rig_${v}`)} customValue={t("other")} name={`${namePrefix}rigElement`} onSelect={selectRig} readOnly={!editable} />
      </BlockField>

      <BlockField label={t("manufacturer")} className="block_field_small_18">
        <input name={`${namePrefix}manufacturer`} defaultValue={data.manufacturer} onChange={onEdited} readOnly={!editable} />
      </BlockField>
      <BlockField label={t("model")} className="block_field_small_18">
        <input name={`${namePrefix}model`} defaultValue={data.model} onChange={onEdited} readOnly={!editable} />
      </BlockField>

      <BlockField label={t("size_height")} className="block_field_small_10">
        <BlockFieldInputs><input className="unit" name={`${namePrefix}size`} defaultValue={data.size} onChange={onEdited} readOnly={!editable} />
          <UnitSelect kind="length" name={`${namePrefix}sizeUnit`} value={data.sizeUnit} editable={editable} onChange={onEdited} />
        </BlockFieldInputs>
      </BlockField>

      <BlockField label={t("place_installation")} className="block_field_small_12">
        <input name={`${namePrefix}placeInstallation`} defaultValue={data.placeInstallation} onChange={onEdited} readOnly={!editable} />
      </BlockField>
      <BlockField label={t("serial_number")} className="block_field_small_1_3">
        <input name={`${namePrefix}serialNumber`} defaultValue={data.serialNumber} onChange={onEdited} readOnly={!editable} />
      </BlockField>
      <BlockField label={t("comment")}>
        <input name={`${namePrefix}comment`} defaultValue={data.comment} onChange={onEdited} readOnly={!editable} />
      </BlockField>
    </ShipSingleRowDataItem>
  );
}
